window.StripeAPI = new function() {
    var self = this;
    var _protected = BaseAPI.call(self);

    self.deletePaymentMethod = function (brandId, paymentMethodId) {
        var deferred = $q.defer();

        _protected.request('stripe/delete_payment_method/' + brandId + '/' + paymentMethodId, "GET")
            .then(function(res){
                if (res.data) {
                    deferred.resolve(res.data);
                }
                else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandPaymentMethods = function (brandId) {
        var deferred = $q.defer();

        _protected.request('stripe/payment_method/' + brandId, "GET")
            .then(function(res){
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.setPrimaryPaymentMethod = function (brandId, creditCardId) {
        var deferred = $q.defer();

        _protected.uniqueRequest('stripe/payment_method/' + brandId, "POST", {credit_card_id: creditCardId})
            .then(function(res){
                if (res.data) {
                    deferred.resolve(res.data);
                }
                else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.addPaymentMethod = function (brandId, creditCardId) {
        var deferred = $q.defer();

        _protected.uniqueRequest('stripe/payment_method/' + brandId, "PUT", {credit_card: creditCardId})
            .then(function (res) {
                if (res.data) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                if (err?.status === 403) {
                    deferred.reject(err.data);
                } else {
                    deferred.reject(err);
                }
            });

        return deferred.promise;
    };

    self.buyPackage = function(payload) {

        var deferred = $q.defer();

        _protected.uniqueRequest("stripe/buy_package", "PUT", payload)
            .then(function(res){
                if (res.data && res.data.status_code === 200) {
                    deferred.resolve(res.data);
                }
                else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.subscribeToPackage = function(brandId, payload) {

        var deferred = $q.defer();

        _protected.uniqueRequest("stripe/subscription/" + brandId, "POST", payload)
            .then(function(res){
                if (res.data && res.data.status_code === 200) {
                    deferred.resolve(res.data);
                }
                else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandTransactions = function (brandId) {
        var deferred = $q.defer();

        _protected.request('stripe/brand_payment_details/' + brandId, "GET")
            .then(function(res){
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.cancelSubscription = function(brandId, subscriptionId) {
        var deferred = $q.defer();
        _protected.uniqueRequest("brands/"+ brandId + "/subscriptions/" + subscriptionId + "/cancel" , "POST")
            .then(function(res){
                if (res.data) {
                    deferred.resolve(res.data);
                }
                else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

};
